export enum ProgressType {
  line = 'line',
  mini = 'mini',
  circle = 'circle',
}
